<template>
    <footer
        class="relative z-10 mt-4 flex w-full flex-col items-center gap-2 border-t border-foam/5 bg-void/40
               px-6 py-1 backdrop-blur-md md:flex-row md:items-center md:justify-between"
    >
        <div class="flex flex-col items-center md:items-start">
            <div class="eyebrow no-select text-[0.65rem] pl-1.5">
                &copy; Funus
            </div>

            <a
                :href="`mailto:${email}`"
                v-text="email"
                class="text-xs font-light tracking-wide text-foam/70 hover:text-white"
            />
        </div>

        <div class="flex items-end gap-4 no-select">
            <a
                v-for="(social, i) in socials"
                :key="i"
                :href="social.url"
                :aria-label="social.name"
                target="_blank"
                rel="noopener noreferrer"
                class="group flex flex-col items-center gap-1 p-2"
            >
                <v-lazy-image
                    :src="`img/socials/${social.name.toLowerCase()}.svg`"
                    class="social-icon block"
                    :title="social.name"
                />

                <span
                    v-text="social.name"
                    class="text-[9px] uppercase tracking-[0.2em] text-foam/50 transition-colors group-hover:text-white"
                />
            </a>
        </div>
    </footer>
</template>

<script>
    // Library
    import { defineComponent } from 'vue';
    import VLazyImage from 'v-lazy-image';
    import store from '@/store/store';

    export default defineComponent({
        name: 'FooterBar',

        components: {
            VLazyImage,
        },

        setup() {
            const at = '@';

            return {
                socials: store.getters.socials,
                email: ['funusbookings', at, 'gmail.com'].join(''),
            };
        },
    });
</script>

<style lang="sass">
    .social-icon
        height: 1.3rem
        width: 1.3rem
        opacity: 0.45
        transition: opacity 0.2s ease, filter 0.2s ease

    a:hover .social-icon
        opacity: 1
        filter: drop-shadow(0 0 6px oklch(0.91 0.01 240 / 45%))
</style>
